


import React, { useEffect, useState } from 'react'
import DashboardNav from '../../components/Nav/DashboardNav'
import search_icon from '../assets/search.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'
import CustomDatePicker from '../../components/CustomDatePicker/CustomDatePicker'
import InfoIcon from '../assets/infoIcon.svg'
import ProgressBarSelector from '../../components/ProgressBarSelector/ProgressBarSelector'
import fullStar from '../../components/Review/assets/fullStar.svg'
import emptyStar from '../../components/Review/assets/emptyStar.svg'
import Footer from '../../components/Footer/Footer'
import RateCountrySelector from '../Rate/RateCountrySelector'
import RateCategorySelector from '../Rate/RateCategorySelector'
import RateEventSelector from '../Rate/RateEventSelector'
import RateVendorSelector from '../Rate/RateVendorSelector'
import errorIcon from '../../components/assets/error.svg';
import successIcon from '../../components/assets/success.svg';
import baseUrl from '../../components/baseUrl'
import axios from 'axios'
import Rate from '../Rate/Rate'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import SuccessModal from '../Rate/Successmodal'


const Edit = ({ reviewData, vendorCountryData, categoryData, eventData, vendorData }) => {
    const navigate = useNavigate()

    const [vendorFound, setVendorFound] = useState(false)
    const [loading, setLoading] = useState(false); // Track loading state
    const [showModal, setShowModal] = useState(false);



    const location = useLocation();
    const review = location.state?.review; // Extract passed review data

    const [user, setUser] = useState(null)
    const [accessToken, setAccessToken] = useState()

    const [country, setCountry] = useState(review.vendor?.vendor_country?.vendor_country_name || "")
    const [category, setCategory] = useState(review.vendor?.category?.category_name || "")
    const [vendor, setVendor] = useState(review.vendor?.vendor_name || "")
    const [vendorId, setVendorId] = useState(review.vendor?.vendor_id || null)
    const [selectedEvent, setEvent] = useState(review?.comments[0]?.event?.event_name || "")
    const [eventId, setEventId] = useState(review?.comments[0]?.event?.event_id || null)
    const [rating, setRating] = useState(review?.rating?.rating_score || 0);
    const [hireAgain, setHireAgain] = useState("");
    const [recommendAgain, setRecommendAgain] = useState("");
    const [comment, setComment] = useState(""); // Initialize with existing comment
    const [ratingId, setRatingId] = useState(review.rating_id || null);
    const [selectedWords, setSelectedWords] = useState([]);
    const [showMore, setShowMore] = useState(false);
    const [estimateAmount, setEstimateAmount] = useState(review?.rating?.service_estimate || null)

    const [isDirty, setIsDirty] = useState(false); // Track if there are changes
    // Error Messages
    const [searchError, setSearchError] = useState('');
    const [countryError, setCountryError] = useState('');
    const [categoryError, setCategoryError] = useState('');
    const [eventError, setEventError] = useState('');
    const [vendorError, setVendorError] = useState('');
    const [rateError, setRateError] = useState('');
    const [eventDate, setEventDate] = useState(null);
    const [commentError, setCommentError] = useState('');
    const [recommendAgainError, setRecommendAgainError] = useState('');
    const [hireAgainError, setHireAgainError] = useState('');
    const [threeWordsError, setthreeWordsError] = useState('');
    const [eventDateError, setEventDateError] = useState('');

    // To keep track of filtered options
    const [filteredVendors, setFilteredVendors] = useState(vendorData);
    const [filteredCountries, setFilteredCountries] = useState(vendorCountryData);
    const [filteredCategories, setFilteredCategories] = useState(categoryData);
    const [filteredEvents, setFilteredEvents] = useState(eventData);


    const [initialRating] = useState(review?.rating?.rating_score); // Store the initial value once
    const [initialEventDate, setInitialEventDate] = useState(null); // Store initial date
    const [initialComment, setInitialComment] = useState(""); // Store initial comment
    const [initialHireAgain, setInitialHireAgain] = useState(""); // Store initial hire again value
    const [initialRecommendAgain, setInitialRecommendAgain] = useState(""); // Store initial recommend again value
    const [initialSelectedWords, setInitialSelectedWords] = useState([]);


    //Open Calendar
    const [openCalendar, setOpenCalendar] = useState(false)

    useEffect(() => {
        if (!review) {
            navigate('/profile'); // Redirect if no review data is found
        }
    }, [review, navigate]);

    const words = [
        'Helpful', 'Considerate', 'Rude', 'Insulting', 'Thoughtful', 'Supportive',
        'Late', 'Arrogant', 'Patient', 'Understanding', 'Unfriendly', 'Pretentious',
        'Ontime', 'Compassionate', 'Blunt', 'Self-centered', 'Friendly',
        'Reassuring', 'Unsympathetic', 'Egotistical'
    ];

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day} - ${month} - ${year}`;
    };

    const handleClick = (index) => {
        setSearchError('');
        const newRating = index + 1;
        setRating(newRating);

        // Check if new rating is different from initial value
        if (newRating !== initialRating) {
            setIsDirty(true); // Mark as dirty if rating changed
        } else {
            setIsDirty(false); // Reset dirty flag if back to initial
        }
    };

    const currencies = [
        { id: 1, name: 'US Dollars', symbol: "USD" },
        { id: 2, name: 'Pound Sterling', symbol: "GBP" },
        { id: 3, name: 'Ghana Cedis', symbol: "GHS" },
        { id: 4, name: 'Naira', symbol: "NGN" },
    ];

    const [selectedCurrency, setSelectedCurrency] = useState({ id: 3, name: 'Ghana Cedis', symbol: "GHS" });

    const handleEstimateAmountChange = (e) => {
        let value = e.target.value;

        // Remove all non-numeric characters (except the decimal point)
        value = value.replace(/[^0-9.]/g, '');

        // Format the number with commas
        const formattedValue = new Intl.NumberFormat().format(value);

        // Update the state with the formatted value
        setEstimateAmount(formattedValue === "0" ? "" : formattedValue);
    };
    // Function to handle vendor selection and automatically filter categories and countries
    const handleVendorSelect = (selectedVendor, vendor_id) => {
        setVendor(selectedVendor);
        setVendorId(vendor_id);
        // Filter categories and countries based on selected vendor
        const vendorCategories = vendorData.filter(v => v.vendor_name === selectedVendor)
            .map(v => v.category.category_name);
        const vendorCountries = vendorData.filter(v => v.vendor_name === selectedVendor)
            .map(v => v.vendor_country.vendor_country_name);

       // setFilteredCategories(categoryData.filter(c => vendorCategories.includes(c.category_name)));
        //setFilteredCountries(vendorCountryData.filter(c => vendorCountries.includes(c.vendor_country_name)));
    };

    // Function to handle event selection and automatically filter events 
    const handleEventSelect = (selectedEvent, event_id) => {
        setEvent(selectedEvent);
        setEventId(event_id);
    };

    // Function to handle category selection and automatically filter vendors and countries
    const handleCategorySelect = (selectedCategory) => {
        setCategory(selectedCategory);

        // Filter vendors and countries based on selected category
        const categoryVendors = vendorData.filter(v => v.category.category_name === selectedCategory)

        // Get the unique category names for the vendors in the selected country
        const categoryCountryNames = [...new Set(categoryVendors.map(v => v.vendor_country.vendor_country_name))];
        const categoryCountries = vendorCountryData.filter(v => categoryCountryNames.includes(v.vendor_country_name))

        setFilteredVendors(categoryVendors);
        //setFilteredCountries(categoryCountries);
    };

    // Function to handle country selection and automatically filter vendors and categories
    const handleCountrySelect = (selectedCountry) => {
        setCountry(selectedCountry);

        // Filter vendors based on the selected country
        const countryVendors = vendorData.filter(v => v.vendor_country.vendor_country_name === selectedCountry);

        // Get the unique category names for the vendors in the selected country
        const countryCategoryNames = [...new Set(countryVendors.map(v => v.category.category_name))];

        // Now, filter the full category data based on the unique category names
        const countryCategories = categoryData.filter(c => countryCategoryNames.includes(c.category_name));

        // Update filtered vendors and categories
        setFilteredVendors(countryVendors);
       // setFilteredCategories(countryCategories);
    };

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setAccessToken(decodedToken)
            setUser(userInfo?.user)
        }
        else {
            navigate('/');
        }
    }, [navigate])

    useEffect(() => {
        setFilteredCountries(vendorCountryData)
        setFilteredEvents(eventData)
        setFilteredCategories(categoryData)
        setFilteredVendors(vendorData)
    }, [vendorCountryData, categoryData, vendorData])


    const Star = ({ filled, onClick }) => (
        <span onClick={onClick} style={{ cursor: 'pointer' }} className='transform transition-all ease-in-out duration-300'>
            {filled ? <img src={fullStar} alt="fullStar" className='w-[23.96px] h-[22.8px] transform transition-all ease-in-out duration-300' /> : <img src={emptyStar} alt="emptyStar" className='w-[28.75px] h-[28.75px] transform transition-all ease-in-out duration-300' />} {/* Use actual star images if you have them */}
        </span>
    );


    const toggleWord = (word) => {
        setSelectedWords((prevSelected) => {
            if (!Array.isArray(prevSelected)) {
                prevSelected = [];
            }

            let updatedWords;
            if (prevSelected.includes(word)) {
                // Remove word if already selected
                updatedWords = prevSelected.filter((w) => w !== word);
            } else if (prevSelected.length < 3) {
                // Add word if less than 3 selected
                updatedWords = [...prevSelected, word];
            } else {
                updatedWords = prevSelected;
            }

            // Compare current selection with initial selection to determine isDirty
            const isDifferent = updatedWords.length !== initialSelectedWords.length ||
                updatedWords.some((word) => !initialSelectedWords.includes(word));

            setIsDirty(isDifferent); // Mark as dirty if selection changed

            return updatedWords;
        });
    };
    // Convert comma-separated string into an array safely
    const parseThreeWords = (threeWordsString) => {
        return threeWordsString ? threeWordsString.split(',').map(word => word.trim()) : [];
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scrolling behavior
        });
    };

    const handleSubmit = async (event) => {


        if (!eventDate) {
            setEventDateError("Event Date is required");
            scrollToTop();
        } else {
            setEventDateError('');
        }
        if (rating === 0) {
            setRateError("Rate is required");
            window.scrollTo({ top: 350, behavior: 'smooth' });
        } else {
            setRateError('');
        }
        if (!comment) {
            setCommentError("Comment is required");
            window.scrollTo({ top: 400, behavior: 'smooth' });
        } else {
            setCommentError('');
        }
        if (!hireAgain) {
            setHireAgainError("Select hire-again option");
            scrollToTop();
        } else {
            setHireAgainError('');
        }
        if (!recommendAgain) {
            setRecommendAgainError("Select recommend-again option");
            scrollToTop();
        } else {
            setRecommendAgainError('');
        }
        if (selectedWords.length === 0) {
            setthreeWordsError("Select at least one description");
            scrollToTop();
        } else {
            setthreeWordsError('');
        }

        // Proceed only if all validations pass
        if (vendor && category && selectedEvent && country && eventDate && rating > 0 && comment && hireAgain && recommendAgain && selectedWords.length > 0) {
            const requestData = {
                rating_score: rating,
                vendor_id: vendorId,
                event_id: eventId,
                comment: comment,
                event_date: eventDate,
                hire_again: hireAgain === 'Yes',
                recommend_again: recommendAgain === 'Yes',
                three_words: selectedWords,
            };

            let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: `${baseUrl}/ratings/${ratingId}/${user.user_id}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`


                },
                data: requestData
            };

            try {
                const response = await axios.request(config);

                if (response.data.success) {
                    setShowModal(true); // Show success modal
                } else {
                    alert("Error: " + response.data.error);
                }
            } catch (error) {
                alert("An error occurred. Please try again.");
            } finally {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        const initial = review.comments[0]?.comment || "";
        setComment(initial);
        setInitialComment(initial); // Store initial comment for comparison
    }, [review.comments]);

    useEffect(() => {
        setRating(review?.rating?.rating_score || 0); // Update when review changes
    }, [review]);

    useEffect(() => {
        const initialWords = parseThreeWords(review?.three_words);
        setSelectedWords(initialWords);
        setInitialSelectedWords(initialWords); // Store initial selection for comparison
    }, [review?.three_words]);


    useEffect(() => {
        const initialDate = review?.comments[0]?.event_date;
        const localDate = new Date(initialDate); // Assuming dynamicDate is in a valid format

        setEventDate(localDate);
        setInitialEventDate(localDate); // Store initial date for comparison
    }, [review]);

    useEffect(() => {
        // Capture initial values for comparison
        const initialHire = review?.hire_again ? "Yes" : "No";
        const initialRecommend = review?.recommend_again ? "Yes" : "No";

        setHireAgain(initialHire);
        setInitialHireAgain(initialHire); // Store for comparison

        setRecommendAgain(initialRecommend);
        setInitialRecommendAgain(initialRecommend); // Store for comparison
    }, [review]);


    const areSameDay = (date1, date2) => {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    };

    const handleDateChange = (date) => {
        if (!date) { 
            setEventDate(null); // Allow clearing the field
            setIsDirty(true);   // Mark as dirty when cleared
            return;             // Exit function to avoid error
        }
    
        const localDate = new Date(date.setHours(0, 0, 0, 0)); // Set time to midnight in local timezone
        setEventDate(localDate);
        setEventDateError(''); // Clear error if any
    
        // Compare with initial value to determine if it's dirty
        if (!areSameDay(localDate, initialEventDate)) {
            setIsDirty(true);  // Mark as dirty if date changed
        } else {
            setIsDirty(false); // Reset dirty flag if back to initial
        }
    };
    

    const handleCommentChange = (e) => {
        const newComment = e.target.value;
        setComment(newComment);

        // Compare with initial value to determine isDirty
        if (newComment !== initialComment) {
            setIsDirty(true);  // Mark as dirty if comment changed
        } else {
            setIsDirty(false); // Reset dirty flag if back to initial
        }
    };

    const handleHireAgainClick = (value) => {
        setHireAgain(value);

        // Compare current value with initial value to determine isDirty
        if (value !== initialHireAgain) {
            setIsDirty(true); // Mark as dirty if changed
        } else if (value === initialHireAgain && recommendAgain === initialRecommendAgain) {
            setIsDirty(false); // Reset if both are back to initial
        }
    };

    const handleRecommendAgainClick = (value) => {
        setRecommendAgain(value);

        // Compare current value with initial value to determine isDirty
        if (value !== initialRecommendAgain) {
            setIsDirty(true); // Mark as dirty if changed
        } else if (value === initialRecommendAgain && hireAgain === initialHireAgain) {
            setIsDirty(false); // Reset if both are back to initial
        }
    };


    useEffect(() => {
        if (review?.rating?.service_estimate_currency) {
            const foundCurrency = currencies.find(
                (currency) => currency.symbol === review?.rating?.service_estimate_currency
            );

            if (foundCurrency) {
                setSelectedCurrency(foundCurrency);
            }
        }
    }, [review]);

    return (
        <div>
            <DashboardNav />
            <div className='px-[24px] md:px-[32px] xl:pr-[101px] xl:pl-[90px] pt-[120px]  md:pt-[150px]  lg:pt-[197px] pb-[60px] w-full flex flex-col'>
                {showModal && (
                    <>

                        <SuccessModal setShowModal={setShowModal} message="Your edit review has been submitted successfully!" page="edit" />

                    </>


                )}


                {/**Error Display */}
                {countryError === "Country is required" || categoryError === "Category is required" || eventError === "Event is required" || searchError === "Country is required" ? (
                    <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                        <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                            <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                            <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                {countryError}
                            </p>
                            <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                {categoryError}
                            </p>
                            <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                {eventError}
                            </p>
                            <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                {vendorError}
                            </p>
                        </div>
                    </div>
                ) : null}


                {/* Large Screen Search */}
                <div className='w-full hidden  md:min-w-[480px]  max-w-[848px]  md:flex flex-grow justify-between flex self-center rounded-[80px] bg-ravbg '>
                    <div className={`w-full flex items-center rounded-[80px]  border border-ravgray bg-ravbg ${searchError === 'Invalid Search' ? 'bg-[#FFDFE4] border-[#EB0728]' : ' '} transform transition-all ease-in-out duration-300`}>
                        <RateCountrySelector disabled={true} selectedCountry={review.vendor?.vendor_country?.vendor_country_name || ""} countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="large" />
                        {/* <div className='border border-[1.5px] h-[25px] bg-ravgray1' /> */}
                        <RateCategorySelector disabled={true} selectedCategory={review.vendor?.category?.category_name || ""} categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="large" />
                        {/* <div className='border border-[1.5px] h-[25px] bg-ravgray1' /> */}
                        <RateVendorSelector disabled={true} selectedVendor={review.vendor?.vendor_name || ""} vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="large" />
                    </div>
                </div>



                {/**Small Screen Search */}
                <div className='w-full flex md:hidden flex-col gap-[10px] sm:px-[32px]'>
                    <RateCountrySelector disabled={true} selectedCountry={review.vendor?.vendor_country?.vendor_country_name || ""} countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="small" />
                    <RateCategorySelector disabled={true} selectedCategory={review.vendor?.category?.category_name || ""} categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="small" />
                    <RateVendorSelector disabled={true} selectedVendor={review.vendor?.vendor_name || ""} vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="small" />
                </div>



                {/* Selected Vendor name */}
                {vendor && (
                    <p className='text-[24px] leading-[32.4px] font-black mt-[32px] text-center'>{vendor}</p>
                )
                }

                <div className='flex flex-col md:flex-row  md:mt-[56px] md:gap-[15px] lg:gap-[18px] mg:gap-[21px]'>
                    {/* first div */}

                    {/* Experience,three words,rate,hire gaian */}
                    <div className='border rounded-[20px] mt-[31px] md:mt-0 md:flex md:flex-1 lg:flex-[1.4] xl:flex-[1.01]'>

                        <div className='bg-rate w-full  rounded-[20px]'>

                            {/** Wrapped top section inside a white div */}
                            <div className='bg-white rounded-[20px] py-[26px] xl:py-[22px] px-[17px] xl:pl-[24px] flex flex-col gap-[17px]'>
                                <p className='text-sm font-black'>Use 3 words to describe this vendor</p>

                                {/** 3 words */}
                                <div className='w-full flex flex-col gap-[27px] items-center justify-center text-center'>
                                    {threeWordsError === "Select at least one description" && (
                                        <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                                            <div className="w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                                <img src={errorIcon} alt="" className="w-[18px] h-[18px]" />
                                                <p className="font-normal text-[#EB0728] text-[12px] leading-[14.56px]">{threeWordsError}</p>
                                            </div>
                                        </div>
                                    )}
                                    <div className="w-full flex flex-wrap gap-x-[10px] gap-y-[17px] items-center">
                                        {[
                                            ...selectedWords, // Show selected words first
                                            ...words.filter((word) => !selectedWords.includes(word)) // Then show unselected words
                                        ].slice(0, 5).map((word) => (
                                            <button
                                                key={word}
                                                onClick={() => toggleWord(word)}
                                                disabled={selectedWords.length >= 3 && !selectedWords.includes(word)}
                                                className={`disabled:text-ravash disabled:cursor-not-allowed px-[15px] h-[30px] rounded-[5px] flex items-center justify-center text-center font-medium text-sm sm:text-[16px] sm:leading-[21.6px] ${selectedWords.includes(word) ? 'bg-[#FEAD00] text-white' : 'bg-ravbg'}`}
                                            >
                                                {word}
                                            </button>
                                        ))}

                                        {showMore && [...selectedWords, ...words.filter((word) => !selectedWords.includes(word))]
                                            .slice(5)
                                            .map((word) => (
                                                <button
                                                    key={word}
                                                    onClick={() => toggleWord(word)}
                                                    disabled={selectedWords.length >= 3 && !selectedWords.includes(word)}
                                                    className={`disabled:text-ravash disabled:cursor-not-allowed px-[15px] h-[30px] rounded-[5px] flex items-center justify-center text-center font-medium text-sm sm:text-[16px] sm:leading-[21.6px] ${selectedWords.includes(word) ? 'bg-[#FEAD00] text-white' : 'bg-ravbg'}`}
                                                >
                                                    {word}
                                                </button>
                                            ))}

                                        {words.length > 5 && (
                                            <button
                                                onClick={toggleShowMore}
                                                className="px-[8px] flex items-center justify-center text-center font-black text-ravblue text-sm sm:text-[16px] sm:leading-[21.6px]"
                                            >
                                                {showMore ? 'less' : '+more'}
                                            </button>
                                        )}
                                    </div>

                                </div>

                                {/** Comment */}
                                <div className='mt-[12px] flex flex-col'>
                                    {commentError === "Comment is required" && (
                                        <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                                            <div className="w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                                <img src={errorIcon} alt="" className="w-[18px] h-[18px]" />
                                                <p className="font-normal text-[#EB0728] text-[12px] leading-[14.56px]">{commentError}</p>
                                            </div>
                                        </div>
                                    )}
                                    <div className='w-full flex'>
                                        <textarea
                                            value={comment}
                                            onChange={handleCommentChange}
                                            name="comment"
                                            id="comment"
                                            placeholder='Tell us about your experience ...'
                                            className={`focus:outline-none  font-medium resize-none w-full max-w-[922px] min-h-[227px]  md:min-h-[207px] ${commentError === "Comment is required" ? "bg-[#FFDFE4] border-solid border-[1px] border-[#EB0728]" : ""} placeholder:text-ravinput text-sm`}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className='px-[25px] md:pl-[37px] pt-[24px] pb-[28px] flex flex-col gap-[15px] rounded-[20px]'>
                                {/** Hire Again Section */}
                                <div className='flex gap-[13px] flex-col  text-white lg:flex-row lg:justify-between '>
                                    {hireAgainError === "Select hire-again option" ? (
                                        <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                                            <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                                <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                                                <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                                    {hireAgainError}
                                                </p>
                                            </div>
                                        </div>
                                    ) : null}
                                    <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you hire this vendor again?</h1>
                                    <div className='flex gap-[10px]'>
                                        <button type='button' onClick={() => handleHireAgainClick('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
                                        <button type='button' onClick={() => handleHireAgainClick('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
                                    </div>
                                </div>
                                {/**Recommend */}
                                <div className='flex gap-[13px] flex-col  text-white lg:flex-row lg:justify-between '>
                                    {recommendAgainError === "Select recommend-again option" ? (
                                        <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                                            <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                                <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                                                <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                                    {recommendAgainError}
                                                </p>
                                            </div>
                                        </div>
                                    ) : null}
                                    <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you recommend this vendor?</h1>
                                    <div className='flex gap-[10px]'>
                                        <button type='button' onClick={() => handleRecommendAgainClick('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
                                        <button type='button' onClick={() => handleRecommendAgainClick('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>



                    {/* second div */}
                    <div className=' md:flex md:flex-1'>
                        <div>
                            {/**Rate  */}
                            <div className=' mt-[54px] md:mt-0 w-full flex items-center gap-[15px]'>
                                {rateError === "Rate is required" ? (
                                    <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                                        <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                            <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                                            <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                                {rateError}
                                            </p>
                                        </div>
                                    </div>
                                ) : null}
                                <h1 className='font-black text-sm'>Rate this vendor</h1>
                                <div className='flex items-center '>
                                    {[...Array(5)].map((_, index) => (
                                        <Star
                                            key={index}
                                            filled={index < rating}
                                            onClick={() => handleClick(index)}
                                        />
                                    ))}
                                </div>
                            </div>


                            <div className='xl:flex items-center gap-[13px] w-full'>
                                {/**Select Event Date */}
                                <div className='mt-[23px] flex flex-col xl:flex-1'>
                                    {eventDateError === "Event Date is required" ? (
                                        <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
                                            <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
                                                <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
                                                <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
                                                    {eventDateError}
                                                </p>
                                            </div>
                                        </div>
                                    ) : null}

                                    <div className='w-full flex flex-col  gap-[11px]'>
                                        <h1 className=' font-black text-sm' >Select event date</h1>
                                        <div
                                            className={`w-full rounded-[80px] ${eventDateError === "Event Date is required"
                                                ? "bg-[#FFDFE4] border-solid border-[1px] border-[#EB0728]"
                                                : "bg-[#E5E5E580] bg-opacity-50"
                                                }`}
                                        >
                                            <CustomDatePicker selectedDate={eventDate} setSelectedDate={handleDateChange} openCalendar={openCalendar} setOpenCalendar={setOpenCalendar} />                                        </div>

                                    </div>
                                </div>

                                {/* Event type */}
                                <div className='mt-[24px] w-full flex flex-col xl:flex-1 gap-[11px]'>
                                    <h1 className=' font-black text-sm' >Select event type</h1>
                                    <RateEventSelector
                                        disabled={true}
                                        selectedEvent={review?.comments[0]?.event?.event_name || ""}
                                        eventError={eventError}
                                        setEventError={setEventError}
                                        eventData={filteredEvents}
                                        handleEventSelect={handleEventSelect}
                                        device="large" />
                                </div>

                            </div>

                            {/* Estimate */}

                            <div className='mt-[19px] xl:mt-[49px] border border-ravgray rounded-[20px] pt-[15px] pb-[24px] lg:pb-[17px] px-[14px]'>

                                {/**Info */}
                                <div className='w-full flex items-center justify-center'>
                                    <div className=' rounded-[10px] bg-[#E7EFF8] max-w-[600px] flex gap-[12px] items-center justify-start pt-[9px] pb-[13px] px-[16px]'>
                                        <img src={InfoIcon} alt="infoIcon" className='size-[20px]' />
                                        <h1 className=' font-bold text-[12px] text-ravblue leading-[16.2px]'>To maintain confidentiality and trustworthiness, we do not disclose your estimate or display them on reviews</h1>
                                    </div>
                                </div>

                                {/**Choose Currency of transaction */}
                                <div className=' mt-[24px] w-full flex flex-col gap-[15px] '>
                                    <h1 className='text-black font-black text-[16px] leading-[21.6px]'>Choose currency of transaction</h1>

                                    <div className="w-full grid grid-cols-2  lg:flex lg:flex-row gap-y-[20px] items-center lg:gap-[7px] xl:gap-[40px] ">
                                        {currencies.map((currency) => (
                                            <label key={currency?.id} className="flex items-center cursor-not-allowed">
                                                <input
                                                    disabled
                                                    type="radio"
                                                    name="currency"
                                                    value={currency?.name}
                                                    checked={selectedCurrency?.name === currency?.name}
                                                    onChange={() => setSelectedCurrency(currency)}
                                                    className="hidden" // Hide the default radio button
                                                />
                                                <div
                                                    className={`flex items-center justify-center 
                                    w-[20px] h-[20px] rounded-full 
                                    bg-white border-[2px] border-solid bg-[#E5E5E580] border-[#E5E5E580]
                                    ${selectedCurrency?.name === currency?.name ? 'bg-white' : ''}`}
                                                >
                                                    {selectedCurrency?.name === currency?.name && (
                                                        <div className="bg-ravash w-[12px] h-[12px] rounded-full"></div>
                                                    )}
                                                </div>
                                                <span className="ml-[11px] lg:ml-[5px] text-[12px] leading-[16.2px] text-ravinput">{currency?.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>



                                {/**Services estimate */}
                                <div className=' mt-[34px] lg:mt-[32px] w-full flex flex-col gap-[15px] items-center '>


                                    <div className='w-full flex flex-col mg:flex-row gap-[15px] mg:items-center  mg:gap-[11px '>
                                        <h1 className=' whitespace-nowrap font-black text-[16px] leading-[21.6px]'>Indicate services estimate:</h1>
                                        <div className='cursor-not-allowed'>
                                            <div className={` w-[234px] lg:w-full  mg:w-[234px] h-[50px] flex gap-[10px] items-center bg-[#E5E5E580] bg-opacity-50 rounded-[80px] overflow-hidden `}>
                                                <div className={`w-[73px] h-full bg-[#E5E5E5] rounded-l-[80px] flex items-center justify-center text-center font-medium text-sm`}>
                                                    <span>{selectedCurrency?.symbol}</span>
                                                </div>
                                                <input
                                                    disabled
                                                    type="text" // Change to text to allow formatted input
                                                    name="amount"
                                                    id="amount"
                                                    value={estimateAmount}
                                                    onChange={handleEstimateAmountChange}
                                                    placeholder='0.00'
                                                    onClick={() => setSearchError('')}
                                                    className="bg-transparent h-[50px] outline-none text-base placeholder:text-ravash cursor-not-allowed"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <button onClick={() => handleSubmit()} type='button' disabled={!isDirty} className={`hidden  mt-[30px] w-full  h-[45px] md:h-[45px] xl:block rounded-[80px] ${isDirty ? 'bg-[#0079FF]' : 'bg-[#A2CEFF]'} flex items-center justify-center text-center font-bold text-white text-[16px] leading-[21.6px]`}>Submit</button>

                        </div>
                    </div>

                </div>



                <button onClick={() => handleSubmit()} type='button' disabled={!isDirty}  className={` mt-[32px] w-full  h-[45px] md:h-[45px] xl:hidden rounded-[80px] ${isDirty ? 'bg-[#0079FF]' : 'bg-[#A2CEFF]'} flex items-center justify-center text-center font-bold text-white text-[16px] leading-[21.6px]`}>Submit</button>

            </div>
            <Footer />
        </div>

    )
}

//     return (
//         <div>
//             <DashboardNav />
//             <div className='px-[32px] md:px-[50px] pt-[157px] pb-[110px] w-full flex flex-col'>
//                 {showModal && (
//                     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//                         <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//                             <h2 className="text-xl font-bold mb-4">Updated Review Submitted Successfully!</h2>
//                             <p className="mb-6">Your updated review has been submitted successfully.</p>
//                             <div className="flex justify-center gap-4">
//                                 <button
//                                     className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                                     onClick={() => {
//                                         setShowModal(false); // Close modal
//                                     }}
//                                 >
//                                     Close
//                                 </button>
//                                 <button
//                                     className="bg-gray-500 text-white px-4 py-2 rounded-md"
//                                     onClick={() => {
//                                         setShowModal(false);
//                                         window.location.href = "/"; // Redirect to home page
//                                     }}
//                                 >
//                                     Go to Home
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}


//                 {/**Large Screen Search */}
//                 <div className=' w-full hidden md:flex items-center justify-center'>
//                     <div className='w-full max-w-[1000px] flex gap-4 justify-between '>
//                         <RateCountrySelector disabled={true} selectedCountry={review.vendor?.vendor_country?.vendor_country_name || ""} countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="large" />
//                         <RateEventSelector
//                             disabled={true}
//                             selectedEvent={review?.comments[0]?.event?.event_name || ""}
//                             eventError={eventError}
//                             setEventError={setEventError}
//                             eventData={filteredEvents}
//                             handleEventSelect={handleEventSelect}
//                             device="large"
//                         />
//                         <RateCategorySelector disabled={true} selectedCategory={review.vendor?.category?.category_name || ""} categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="large" />

//                         <div className='w-full flex'>
//                             <RateVendorSelector disabled={true} selectedVendor={review.vendor?.vendor_name || ""} vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="large" />
//                         </div>
//                     </div>
//                 </div>


//                 {/**Small Screen Search */}
//                 <div className='w-full flex md:hidden flex-col gap-3 sm:px-[32px]'>
//                     <RateCountrySelector disabled={true} selectedCountry={review.vendor?.vendor_country?.vendor_country_name || ""} countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="small" />
//                     <RateEventSelector disabled={true} selectedEvent={review?.comments[0]?.event?.event_name || ""} eventError={eventError} setEventError={setEventError} eventData={filteredEvents} handleEventSelect={handleEventSelect} device="small" />
//                     <RateCategorySelector disabled={true} selectedCategory={review.vendor?.category?.category_name || ""} categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="small" />

//                     <div className='w-full flex'>
//                         <RateVendorSelector disabled={true} selectedVendor={review.vendor?.vendor_name || ""} vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="small" />
//                     </div>
//                 </div>

//                 {/**Select Event Date */}
//                 <div className='mt-[36px] flex flex-col'>
//                     {eventDateError === "Event Date is required" ? (
//                         <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
//                             <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                 <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                 <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                     {eventDateError}
//                                 </p>
//                             </div>
//                         </div>
//                     ) : null}

//                     <div className='w-full flex flex-col sm:flex-row items-center justify-center gap-4'>
//                         <h1 className='font-black text-[16px] leading-[21.6px]'>Select event date</h1>
//                         <div
//                             onClick={() => {
//                                 setOpenCalendar(!openCalendar);
//                             }}
//                             className={`w-full sm:w-auto rounded-[80px] ${eventDateError === "Event Date is required" ? "bg-[#FFDFE4] border-solid border-[1px] border-[#EB0728]" : "bg-[#E5E5E580] bg-opacity-50"}`}
//                         >
//                             <CustomDatePicker
//                                 selectedDate={eventDate}
//                                 setSelectedDate={handleDateChange}
//                                 openCalendar={openCalendar}
//                                 setOpenCalendar={setOpenCalendar}
//                             />
//                         </div>
//                     </div>

//                 </div>



//                 {/**Rate  */}
//                 <div className=' mt-[65px] w-full flex flex-col items-center justify-center gap-[6px]'>
//                     {rateError === "Rate is required" ? (
//                         <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
//                             <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                 <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                 <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                     {rateError}
//                                 </p>
//                             </div>
//                         </div>
//                     ) : null}
//                     <h1 className='font-black text-[16px] leading-[21.6px]'>Rate this vendor</h1>
//                     <div className='flex items-center'>
//                         {[...Array(5)].map((_, index) => (
//                             <Star
//                                 key={index}
//                                 filled={index < rating}
//                                 onClick={() => handleClick(index)}
//                             />
//                         ))}
//                     </div>
//                 </div>

//                 {/**Comment  */}
//                 <div className='mt-[37px] flex flex-col'>
//                     {commentError === "Comment is required" ? (
//                         <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
//                             <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                 <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                 <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                     {commentError}
//                                 </p>
//                             </div>
//                         </div>
//                     ) : null}
//                     <div className='w-full flex items-center justify-center'>
//                         <textarea
//                             value={comment}
//                             onChange={handleCommentChange}
//                             name="comment"
//                             id="comment"
//                             placeholder='Enter comments here'
//                             className={`focus:outline-[#0079FF] resize-none w-full max-w-[922px] min-h-[150px] sm:min-h-[182px] ${commentError === "Comment is required" ?
//                                 "bg-[#FFDFE4] border-solid border-[1px] border-[#EB0728]" :
//                                 "bg-[#E5E5E580] bg-opacity-50"
//                                 } placeholder:text-[#707070] text-[15px] leading-[20.25px] rounded-[30px] sm:rounded-[40px] px-[30px] sm:px-[47px] py-[19px] sm:py-[27px]`}
//                         />
//                     </div>
//                 </div>

//                 {/**Feedback */}
//                 <div className=' mt-[30px] w-full flex flex-wrap items-center justify-center gap-[20px]'>
//                     {/**Hire */}
//                     <div className='flex gap-[13px] flex-wrap items-center justify-center'>
//                         {hireAgainError === "Select hire-again option" ? (
//                             <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
//                                 <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                     <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                     <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                         {hireAgainError}
//                                     </p>
//                                 </div>
//                             </div>
//                         ) : null}
//                         <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you hire this vendor again?</h1>
//                         <div className='flex gap-[10px]'>
//                             <button type='button' onClick={() => handleHireAgainClick('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-[#E5E5E580] bg-opacity-50 text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
//                             <button type='button' onClick={() => handleHireAgainClick('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-[#E5E5E580] bg-opacity-50 text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
//                         </div>
//                     </div>
//                     {/**Recommend */}
//                     <div className='flex gap-[13px] flex-wrap items-center justify-center'>
//                         {recommendAgainError === "Select recommend-again option" ? (
//                             <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
//                                 <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                     <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                     <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                         {recommendAgainError}
//                                     </p>
//                                 </div>
//                             </div>
//                         ) : null}
//                         <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you recommend this vendor again?</h1>
//                         <div className='flex gap-[10px]'>
//                             <button type='button' onClick={() => handleRecommendAgainClick('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-[#E5E5E580] bg-opacity-50 text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
//                             <button type='button' onClick={() => handleRecommendAgainClick('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-[#E5E5E580] bg-opacity-50 text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
//                         </div>
//                     </div>
//                     {/**3 words */}
//                     <div className=' mt-[52px] w-full flex flex-col gap-[27px] items-center justify-center text-center'>
//                         {threeWordsError === "Select at least one description" ? (
//                             <div className='w-full flex items-center justify-center mb-[20px] transform transition-all ease-in-out duration-300'>
//                                 <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] border-solid border-[1px] border-[#EB0728] px-[12px] py-[3px]">
//                                     <img src={errorIcon} alt="" className=" w-[18px] h-[18px]" />
//                                     <p className=" font-normal text-[#EB0728] text-[12px] leading-[14.56px]">
//                                         {threeWordsError}
//                                     </p>
//                                 </div>
//                             </div>
//                         ) : null}
//                         <h1 className='font-black text-[16px] leading-[21.6px]'>Use 3 words to describe this vendor</h1>
//                         <div className="w-full max-w-[922px] flex flex-wrap gap-[16px] items-center justify-center">
//                             {words.map((word) => (
//                                 <button
//                                     key={word}
//                                     onClick={() => toggleWord(word)}
//                                     disabled={selectedWords.length >= 3 && !selectedWords.includes(word)}
//                                     className={`disabled:opacity-30 disabled:cursor-not-allowed w-[140px] h-[35px] sm:w-[150px] sm:h-[40px] rounded-[10px] flex items-center justify-center text-center font-medium text-black text-[14px] sm:text-[16px] sm:leading-[21.6px] ${selectedWords.includes(word) ? "bg-[#0079FF] text-white" : "bg-[#E5E5E580] bg-opacity-50"
//                                         }`}
//                                 >
//                                     {word}
//                                 </button>
//                             ))}
//                         </div>

//                     </div>

//                     <button
//                         onClick={handleSubmit}
//                         type='button'
//                         className={`mt-[41px] w-full max-w-[500px] h-[50px] rounded-[80px] ${isDirty ? 'bg-[#0079FF]' : 'bg-[#A2CEFF]'} flex items-center justify-center text-center font-bold text-white text-[16px] leading-[21.6px]`}
//                         disabled={!isDirty} // Disable button if no changes
//                     >
//                         Submit
//                     </button>                </div>
//             </div>
//             <Footer />
//         </div>
//     )
// }

export default Edit
